import { Paper } from "@mantine/core";
import { regionApi } from "apis/regionApi";
import { Loading } from "components";
import { ErrorStatusType } from "constants/types/common";
import { RegionRequestBodyType } from "constants/types/region";
import { useFormik } from "formik";
import { FORM_IDS } from "pages/Region/config";
import { FC, useState } from "react";
import { useNotification } from "utils/hooks";
import RegionFormFields from "../RegionFormFields/RegionFormFields";
import { createValidationSchema } from "./config";

interface CreateFormProps {
  onClose?: () => void;
  mutate?: () => void;
}

const CreateForm: FC<CreateFormProps> = ({ onClose, mutate }) => {
  const { notification } = useNotification();
  const [isLoading, setIsLoading] = useState(false);

  const formik = useFormik<RegionRequestBodyType>({
    initialValues: {
      code: "",
      name: "",
      notes: "",
    },
    validationSchema: createValidationSchema,
    onSubmit: async (values) => {
      setIsLoading(true);
      try {
        const res = await regionApi.create(values);
        if (res.data.success) {
          notification.success({ title: "Tạo địa bàn thành công" });
          onClose?.();
          mutate?.();
          formik.resetForm();
        }
      } catch (error: ErrorStatusType | any) {
        notification.error({ title: "Tạo địa bàn thất bại", message: error?.error?.message });
      }
      setIsLoading(false);
    },
  });

  return (
    <Loading variant="overlay" visible={isLoading}>
      <Paper>
        <form id={FORM_IDS.CREATE} onSubmit={formik.handleSubmit}>
          <RegionFormFields formik={formik} isCreateMode />
        </form>
      </Paper>
    </Loading>
  );
};

export default CreateForm;
